'use strict';

/*eslint-disable */
module.exports = {
    easingFunctions: function (st, ed, per, easing) {
        var functions = {
            // quadratic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuad: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;

                return -c / 2 * (t * (t - 2) - 1) + b;
            }
        };

        return functions[easing](per, st, ed - st, 1);
    }
};
/*eslint-enable */
